import React, { useEffect, useState } from 'react';

import type { ButtonAsType, ButtonProps } from '@motorway/mw-highway-code';
import { Button, FiltersIcon, MagnifyingGlassIcon } from '@motorway/mw-highway-code';
import { Input } from '@motorway/mw-highway-code/alpha';

import useAccountRouter from 'Components/Account/useAccountRouter';
import cypressIds from 'Components/cypress_ids.json';
import { applyCypressData } from 'Utilities/helpers';

import styles from './AccountInputWithButton.module.scss';

const {
	buttons: { purchaseCompleteMobileFilter },
} = cypressIds;

interface AccountInputWithButtonProps extends Omit<ButtonProps<ButtonAsType>, 'label'> {
	inputConfig: {
		inputProps: {
			id: string;
			initialValue: string;
			input: {
				name: string;
				placeholder: string;
			};
		};
	};
	onButtonClick: () => void;
	onClearInput?: () => void;
	onInputChange?: (value: string) => void;
}

const AccountInputWithButton: React.FC<AccountInputWithButtonProps> = ({
	inputConfig,
	onButtonClick,
	onClearInput,
	onInputChange,
}) => {
	const { keyword } = useAccountRouter();
	const [inputValue, setInputValue] = useState(keyword || inputConfig?.inputProps?.initialValue || '');

	useEffect(() => {
		if (!keyword) {
			setInputValue('');
		}
	}, [keyword]);

	const handleInputChange = (value: string) => {
		setInputValue(value);
		if (!value) {
			onClearInput?.();
		} else {
			onInputChange?.(value);
		}
	};

	return (
		<div className={styles.container}>
			<Input
				{...inputConfig}
				formProps={{
					...inputConfig.inputProps,
					input: {
						onChange: (e: React.ChangeEvent<HTMLInputElement>) => handleInputChange(e?.target?.value),
						value: inputValue,
						...inputConfig?.inputProps?.input,
						...applyCypressData(purchaseCompleteMobileFilter.purchaseCompleteMobileFilterInput),
						'aria-label': inputConfig.inputProps.input.placeholder,
						type: 'search',
					},
				}}
				id={inputConfig.inputProps.id}
				label={inputConfig.inputProps.input.placeholder}
				prepend={MagnifyingGlassIcon}
				showLabel={false}
			/>
			<div className={styles.buttonContainer}>
				<Button
					data-thc-button
					icon={FiltersIcon}
					label="filters"
					onClick={onButtonClick}
					showLabel={false}
					type="button"
					variant="secondary"
					{...applyCypressData(purchaseCompleteMobileFilter.purchaseCompleteMobileFilterButton)}
				/>
			</div>
		</div>
	);
};

export default AccountInputWithButton;
